import { lazily } from 'react-lazily'

import { wrapSuspense, wrapVisibleSuspense } from '../../atoms/placeholders/Suspense'

const { RKVSTSwitch: RawRKVSTSwitch, ON: RawON, OFF: RawOFF } = lazily(() => import('./SwitchButton'))
const RKVSTSwitch = wrapVisibleSuspense<typeof RawRKVSTSwitch>(RawRKVSTSwitch)
const ON = wrapSuspense<typeof RawON>(RawON)
const OFF = wrapSuspense<typeof RawOFF>(RawOFF)
export { OFF, ON, RKVSTSwitch }
